export default __webpack_public_path__ + "static/media/carlos-caminha.38c025bd.jpg";